import SummaryApi from "../common";
import { request } from "./request";

const fetchCategoryWiseProduct = async (category) => {
  try {
    const queryString = category
      ? `?category=${encodeURIComponent(category)}`
      : "";

    const response = await request({
      url: `${SummaryApi.categoryWiseProduct.url}${queryString}`,
      method: SummaryApi.categoryWiseProduct.method,
    });

    const dataResponse = await response.json();
    return dataResponse;
  } catch (error) {
    console.error("Error fetching category wise product", error);
    return { success: false, data: [] };
  }
};

export default fetchCategoryWiseProduct;
